// @mui
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
// theme
import { bgBlur } from 'src/theme/css';
// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
import { useSettingsContext } from 'src/components/settings';
import SvgColor from 'src/components/svg-color';
//
import {
  AccountPopover,
  LanguagePopover,
  Searchbar,
     NotificationsPopover,
    SettingsButton,
} from '../_common';
import { HEADER, NAV } from '../config-layout';
import {PopupWidget} from "react-calendly";
import {useMockedUser} from "../../hooks/use-mocked-user";
import {LoggedInUser} from "../../types/user";
import {useNavigate} from "react-router-dom";
import {useLocales} from "../../locales";
import {useContext, useState,useEffect} from "react";
import {Auth0ContextType} from "../../auth/types";
import {AuthContext} from "../../auth/context/jwt";

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
};

export default function Header({ onOpenNav }: Props) {
  const theme = useTheme();

  const settings = useSettingsContext();

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useResponsive('up', 'lg');

  const offset = useOffSetTop(HEADER.H_DESKTOP);

  const offsetTop = offset && !isNavHorizontal;
    const { initialize } = useContext(AuthContext);

    const mockedUser = useMockedUser() as Auth0ContextType;
    const user = mockedUser.user as LoggedInUser;

    const [renderKey, setRenderKey] = useState(0);

    // Effect to re-render NotificationsPopover on each render
    useEffect(() => {
        // Update the render key whenever Header re-renders
        setRenderKey(prevKey => prevKey + 1);
        const intervalId = setInterval(() => {
            initialize();
            setRenderKey(prevKey => prevKey + 1);
        }, 7000); // Fetch user data every 5 seconds


    }, [initialize]); // Empty dependency array ensures this effect runs only once on mount



    const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}

      {!lgUp && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
        </IconButton>
      )}



      <Searchbar />


      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1 }}
      >
        <LanguagePopover />
          {/* <NotificationsPopover /> */}
          <SettingsButton />


          <NotificationsPopover key={renderKey} recentresponses={user ? user.recentresponses : []} />

        {/* <ContactsPopover /> */}

        {/* <SettingsButton /> */}

        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
